// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Switch when component is rendered should render component without errors and match snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <span
        class="MuiSwitch-root MuiSwitch-sizeMedium css-4up829-MuiSwitch-root"
      >
        <span
          class="MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase"
        >
          <input
            class="PrivateSwitchBase-input MuiSwitch-input css-1m9pwf3"
            data-size="medium"
            data-theme="default"
            type="checkbox"
          />
          <span
            class="MuiSwitch-thumb css-jsexje-MuiSwitch-thumb"
          />
          <span
            class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"
          />
        </span>
        <span
          class="MuiSwitch-track css-1yjjitx-MuiSwitch-track"
        />
      </span>
    </div>
  </body>,
  "container": <div>
    <span
      class="MuiSwitch-root MuiSwitch-sizeMedium css-4up829-MuiSwitch-root"
    >
      <span
        class="MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase"
      >
        <input
          class="PrivateSwitchBase-input MuiSwitch-input css-1m9pwf3"
          data-size="medium"
          data-theme="default"
          type="checkbox"
        />
        <span
          class="MuiSwitch-thumb css-jsexje-MuiSwitch-thumb"
        />
        <span
          class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"
        />
      </span>
      <span
        class="MuiSwitch-track css-1yjjitx-MuiSwitch-track"
      />
    </span>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
